import React, { Component } from 'react';
import { Button, ButtonGroup, FormControl } from 'react-bootstrap';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
import { parseString } from 'xml2js';
import docDefinition from './pdf_structure';
import docDefinition1 from './pdf_structure_new';
import docDefinition2 from './pdf_structure_new2';
import docDefinition2025 from './pdf_structure_2025';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
class App extends Component {
  constructor(props) {
    super(props);		
    this.state = {
      number: '',
      years: this.getYears(),
      quarters: ['I', 'II', 'III', 'IV'],
      selectedYear: this.getYears()[0],
      selectedQuarter: 'I'
    };
    this.getPeriod();
    fetch('today')
      .then(response => response.text())
      .then(today => this.setState({ today }));
  }
  getPeriod() {
    const year = this.state.selectedYear;
    const quarter = this.state.selectedQuarter;
    fetch(`period?year=${year}&quarter=${quarter}`)
    .then(response => response.text())
    .then(text => {
      let string;
      if (text.trim() === 'None') {
        string = 'За данный период статистика отсутствует';
      } else {
        string = 'Количество посещений за заданный период: ' + (Number(text) + 1);
      }
      this.setState({ period: string });
    });
  }
  genPDF(err, data, action) {
    if (err) {
      this.setState({ error: 'Данные не найдены' });
      return;
    } else {
      this.setState({ error: '' });
    }
		// eslint-disable-next-line
    const uins = data.bill.billPoint.map(e => e.uin).map(e => e ? e : 0);
      
    const genBarCode = uin => {
      const img = new Image();
        JsBarcode(img, uin, {
          format: "CODE128",
          width: 1,
          height: 30,
          displayValue: false
        });
        return img.src;
    };
		/*-----------------*/
    const genQrCode = (uin, lastname, middlename, firstname, address, sum, period, account) => {
			var qrcode = new QRCode.Encoder();
			qrcode.setEncodingHint(true).setErrorCorrectionLevel(QRCode.ErrorCorrectionLevel.L);
			let qrstring = 'ST00012|Name= УФК по Самарской области (Департамента по управлению муниципальным имуществом администрации городского округа Тольятти)|PersonalAcc=03100643000000014200|BankName=ОТДЕЛЕНИЕ САМАРА БАНКА РОССИИ//УФК по Самарской области, г. Самара|BIC=013601205|CorrespAcc=40102810545370000036|PayeeINN=6320001741|KPP=632431001|CBC=90311109044040004120|OKTMO=36740000';
				qrstring += '|UIN=' + uin;
				qrstring += '|LastName=' + lastname;
				qrstring += '|MiddleName=' + middlename;
				qrstring += '|FirstName=' + firstname;
				qrstring += '|PayerAddress=' + address;
				qrstring += '|Sum=' + String(sum);
				qrstring += '|PaymPeriod=' + period;
				qrstring += '|PersAcc=' + String(account);
				qrstring += '|Purpose=Оплата найма муниципального жилого помещения';
			qrcode.write(qrstring);
			qrcode.make();
			return qrcode.toDataURL();
    };
		function sleep (time) {
			return new Promise((resolve) => setTimeout(resolve, time));
		}
		async function getPNG(i) {
			var img = new Image();
			img.src = i;
			await sleep(100);
			var canvas = document.createElement('CANVAS');
			var ctx = canvas.getContext('2d');
			canvas.height = img.naturalHeight;
			canvas.width = img.naturalWidth;
			ctx.drawImage(img, 0, 0);
			return Promise.resolve(canvas.toDataURL('image/png'));
		}
		
		
		
		let gif = genQrCode(
			data.bill.uin ? data.bill.uin[0] : data.bill.contractNumber,
			data.bill.person[0].fullname[0].split(" ")[0],
			"",
			"",
			data.bill.address[0],
			data.bill.billPoint[0].duty[0],
			data.bill.pastPayPeriod ? data.bill.pastPayPeriod[0] : "период",
			data.bill.contractNumber
		);
		getPNG(gif).then(function(result) {
			data.bill.barCode = result;
			
			/*Условие: Если выбран период ранее 1 квартала 2019 года, то формируем старую форму квитанции, 
			после этого периода, новую*/
			if ((year === "2019" && quarter === 'I') || year < 2019  ) {
				data.bill.barCode = genBarCode(data.bill.uin);
				pdfMake.createPdf(docDefinition(data))[action]();
			}
			else if ((year === "2019" && (quarter === 'II' || quarter === 'III' || quarter === 'IV')) || (year === "2020" && (quarter === 'I' || quarter === 'II'))) {
				pdfMake.createPdf(docDefinition1(data))[action]();
			}
			else if (year < "2025") {
				pdfMake.createPdf(docDefinition2(data))[action]();
			}
            else {
                pdfMake.createPdf(docDefinition2025(data))[action]();
            }
			//Создем квитанцию
		});
		
		//data.bill.barCode = genBarCode(data.bill.uin);
		
		data.bill.billPoint = data.bill.billPoint
		//.map((e, i) => ({ ...e, barCode: genQrCode(e.uinm[0], data.bill.person[0].fullname[0].split(" ")[0], "", "", data.bill.address[0], data.bill.paySumm[0], e.charDate[0], data.bill.contractNumber) }));
			.map((e, i) => ({ ...e, barCode: genBarCode(e.uin) }));
			
		
    const year = this.state.selectedYear;
    const quarter = this.state.selectedQuarter;
  }
  send(action) {
    const s = this.state;
    if (Number.parseInt && Number.isNaN(Number.parseInt(s.number, 10))) {
      alert('Неправильный код');
      return;
    }
    const callback = text =>
      parseString(text, (err, res) => this.genPDF(err, res, action));
    fetch(`send?number=${s.number}&year=${s.selectedYear}&quarter=${s.selectedQuarter}`)
      .then(response => response.text())
      .then(callback);
  }
  getYears() {
    let year = new Date().getFullYear();
    let years_arr = [];
    while (year > 2010) {
      years_arr.push(year--);
    }
    return years_arr;
  }
  render() {
    return <div>
      <select
        onChange={e => this.setState({ selectedQuarter: e.target.value }, this.getPeriod.bind(this))}
        className="form-control">
        {this.state.quarters
          .map((e, key) => <option {...{ key }}>{e}</option>)}
      </select>
      <select
        onChange={e => this.setState({ selectedYear: e.target.value }, this.getPeriod.bind(this))}
        className="form-control">
        {this.state.years
          .map((e, key) => <option {...{ key }}>{e}</option>)}
      </select>
      <FormControl
        onChange={e => this.setState({ number: e.target.value })}
        value={this.state.number}
        placeholder="Номер лицевого счета"
        className="form-control" />
        <ButtonGroup>
      <Button onClick={() => this.send('open')}>Просмотр</Button>
      <Button onClick={() => this.send('download')}>Cохранить</Button>
      <Button onClick={() => this.send('print')}>Печать</Button>
      </ButtonGroup>
      <br />
      <label>{this.state.error}</label>
      <br />
      <div>
        <p>{this.state.period}</p>
        <p>{this.state.today}</p>
      </div>
    </div>;
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js